/* src/components/Hero/Hero.jsx */
import "./Hero.css"
import {usePanelStatus} from "../HorizontalScroll/panelStatus.js";
import {PhoneTapIcon} from "../icons/TapIcon.jsx";

const MARQUEE = Array.from({length: 8});   // копії для безшовного циклу (-50%)

const STATUS_CLASS = {
	after: 'is-armed',
	active: 'is-in',
	before: 'is-out',
	static: null,
};

const Hero = () => {
	const status = usePanelStatus();
	const classes = ['hero', STATUS_CLASS[status]].filter(Boolean).join(' ');

	return (
		<section className={classes}>
			<h1 className="hero__title">
				<span className="hero__title-track">
					{MARQUEE.map((_, i) => (
						<span
							className="hero__title-copy"
							key={i}
							aria-hidden={i === 0 ? undefined : 'true'}
						>
							Готова<br className="hero__title-br" /> до вкладання
						</span>
					))}
				</span>
			</h1>

			<div className="hero__container">
				<img src='/images/hero.webp' className="hero__img" alt='Готова до вкладання'/>

				<div className="hero__guide">
					<div className='hero__guide_point'>
						<div className='hero__guide_round'>1</div>
						<span>Купіть</span>
					</div>
					<div className='hero__guide_point'>
						<div className='hero__guide_round'>2</div>
						<span>Розпакуйте</span>
					</div>
					<div className='hero__guide_point'>
						<div className='hero__guide_round'>3</div>
						<span>Вмостіть</span>
					</div>
				</div>
			</div>

			<div className="hero__tap" aria-hidden="true">
				<PhoneTapIcon />
			</div>
		</section>
	);
};

export default Hero;